<template>
  <div>
    <div class="tool_box" v-if="!props.isEdit && !props.editData">
      <a-button
        @click="
          fileExport({
            name: `（业主）车辆预约批量申请Excel模板.xlsx`,
            url: `/api/carApplications/template/getProprietor`,
          })
        "
      >
        业主批量导入模板
      </a-button>
      &nbsp; &nbsp;
      <FileUpload
        :showList="false"
        url="/carApplications/import/proprietor"
        fileField="file"
        @uploadSuccess="bulkImportSuccess"
        @error="bulkImportError"
        v-if="props.ableProImport"
      >
        <a-button type="primary">业主批量导入</a-button>
      </FileUpload>
      &nbsp; &nbsp;
      <a-button
        @click="
          fileExport({
            name: `（施工）车辆预约批量申请Excel模板.xlsx`,
            url: `/api/carApplications/template/getBuild`,
          })
        "
      >
        施工批量导入模板
      </a-button>
      &nbsp; &nbsp;
      <FileUpload
        :showList="false"
        url="/carApplications/import/build"
        fileField="file"
        @uploadSuccess="bulkImportSuccess"
        @error="bulkImportError"
        v-if="props.ableBuildImport"
      >
        <a-button type="primary">施工批量导入</a-button>
      </FileUpload>
    </div>
    <multiple_form
      :forms="forms"
      :edit="props.canEdit"
      :editData="props.editData"
      :disabled="props.disabled"
      :submitBtn="!props.isDetail"
      :disabledDate="disabledDate"
      ref="multipleFormRef"
      @submit="handelSubmit"
    />
  </div>
</template>
<script setup>
  import { ref, defineProps, defineEmits, computed, toRefs } from 'vue'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'
  import {
    createData,
    updateData,
  } from '@/api/car_application/enterprise_application'
  import multiple_form from '@/components/multiple_form'
  import { gender, cargoType, areaTypeConst } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  import { fileExport } from '@/utils/download'
  import FileUpload from '@/components/form/file_upload'
  import dayjs from 'dayjs'

  const store = useStore()

  const disabledDate = (current) => {
    return current && current < dayjs().subtract(1,'days').endOf('day')
  }
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    canEdit: {
      default: true,
    },
    editData: Object,
    data: Array,
    idField: String,
    disabled: Boolean,
    isDetail: { type: Boolean, default: false },
    ableBuildImport: { default: false },
    ableProImport: { default: false }
  })
  const emit = defineEmits(['submit', 'error', 'change'])
  const showDanger = ref(props.editData?.cargo_type == '1')
  const { carModelObj, deptType } = toRefs(store.state?.common)
  const showCargo = ref(
    !!carModelObj.value[props?.editData?.vehicle_type_id]?.show_cargo_type
  )
  const showDumpTruck = ref(false)  // 展示泥头车信息
  const showSpecialVehicleFields = ref(false)  // 展示特殊车型字段（申请类型、来访时间）
  const need_record = ref(0)
  const need_blind_video = ref(0)
  const need_trailer_registration = ref(0)
  const need_truck_driver_license = ref(0)
  const need_truck_compulsory_insurance = ref(0)
  const need_truck_commercial_insurance = ref(0)
  const detailNeedRecord = computed(() => {
    return props.editData?.vehicle_type?.need_record != 1
  })
  const detailNeedVideo = computed(() => {
    return props.editData?.vehicle_type?.need_blind_video != 1
  })
  const detailNeedTrailerRegistration = computed(() => {
    return props.editData?.vehicle_type?.need_trailer_registration != 1
  })
  const detailNeedTruckDriverLicense = computed(() => {
    return props.editData?.vehicle_type?.need_truck_driver_license != 1
  })
  const detailNeedTruckCompulsoryInsurance = computed(() => {
    return props.editData?.vehicle_type?.need_truck_compulsory_insurance != 1
  })
  const detailNeedTruckCommercialInsurance = computed(() => {
    return props.editData?.vehicle_type?.need_truck_commercial_insurance != 1
  })
  if(props.editData) {
    showDumpTruck.value = props.editData?.vehicle_type?.name?.indexOf('泥头车') > -1
    showSpecialVehicleFields.value =
      props.editData?.vehicle_type?.name?.includes('危') ||
      props.editData?.vehicle_type?.name?.includes('自卸货车') ||
      props.editData?.vehicle_type?.name?.includes('泥头车')
  }

  const isDangerVehicle = ref(props.editData?.vehicle_type?.name.includes('危')) // 是否含“危”车型
  const departType = ref(props.editData?.depart_info?.depart_type || 0) // 部门类型
  const currentVisitorType = ref(props.editData?.visitor_type)

  // 显示“工作证明图片”逻辑：
  // 1. 访问非政府部门 depart_type != 2
  // 2. 非危车型
  // 3. 服务商来访
  const showWorkCertificatePhoto = computed(() => {
    return currentVisitorType.value == 5 && !isDangerVehicle.value && (departType.value != 0 && departType.value != 2)
  })

  const multipleFormRef = ref()
  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '申请人（司机）信息',
      id: 'applicant_information',
      formItem: [
        // 司机作为申请人
        /*{
          type: 'input',
          field: 'applicant_name',
          label: '姓名',
        },
        {
          type: 'select',
          field: 'visitor_idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'applicant_idcard',
          label: '证件号码',
        },
        {
          type: 'select',
          field: 'applicant_gender',
          options: constantToOptions(gender),
          label: '性别',
        },
        {
          type: 'input',
          field: 'applicant_phone',
          label: '联系电话',
        },*/
        {
          type: 'input',
          field: 'visitor_company',
          label: '来访单位',
        },
      ],
    },
    {
      name: '车辆信息',
      id: 'vehicle_information',
      formItem: [
        {
          type: 'select',
          field: 'vehicle_type_id',
          label: '车型(行驶证)',
          storeOptions: 'carModel',
          onChange: (e) => {
            showCargo.value = !!carModelObj.value[e]?.show_cargo_type
            need_record.value = carModelObj.value[e]?.need_record
            need_blind_video.value = carModelObj.value[e]?.need_blind_video
            need_trailer_registration.value = carModelObj.value[e]?.need_trailer_registration
            need_truck_driver_license.value = carModelObj.value[e]?.need_truck_driver_license
            need_truck_compulsory_insurance.value = carModelObj.value[e]?.need_truck_compulsory_insurance
            need_truck_commercial_insurance.value = carModelObj.value[e]?.need_truck_commercial_insurance
            showDumpTruck.value = carModelObj.value[e].name?.indexOf('泥头车') > -1
            isDangerVehicle.value = carModelObj.value[e].name.includes('危')
            showSpecialVehicleFields.value =
              carModelObj.value[e].name?.includes('危') ||
              carModelObj.value[e].name?.includes('自卸货车') ||
              carModelObj.value[e].name?.includes('泥头车')
          },
        },
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
        },
        {
          type: 'select',
          field: 'license_plate_color',
          storeOptions: 'plateColorType',
          getName: true,
          label: '车牌颜色',
        },
        {
          type: 'select',
          field: 'color_id',
          label: '车辆颜色',
          storeOptions: 'vehicleColorType',
        },
        {
          type: 'input',
          field: 'vehicle_license_number',
          label: '车辆识别代号',
        },
        /*{
          type: 'input',
          field: 'engine_number',
          label: '发动机号码',
        },*/
        {
          type: 'input',
          field: 'trailer_license',
          label: '挂车号牌',
          required: false,
        },
        {
          type: 'radio',
          field: 'cargo_type',
          options: constantToOptions(cargoType),
          label: '货物类型',
          hidden: !showCargo.value,
          onChange: cargoTypeChange,
        },
        {
          type: 'input',
          field: 'cargo_name',
          label: '货物名称',
          hidden: !showCargo.value,
        },
        {
          type: 'input',
          field: 'total_mass',
          label: '车辆总质量KG(行驶证)',
          hidden: !showCargo.value,
        },
        {
          type: 'input',
          field: 'remark',
          label: '备注',
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'vehicle_img',
          label: '车辆照片',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'img12123',
          // label: '12123交警平台车辆信息截图或行驶证正反面（有最新年检记录）、交强险保单图片（货车类型必须加车身侧面图片；重型大车必须加商业险保单图片）',
          label: '12123交警平台车辆信息截图、行驶证正反面（有最新年检记录）（货车类型必须加车身侧面图片）',
          number: 20,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'truck_driver_license_photo',
          label: '驾驶证图片',
          number: 10,
          hidden: !props.canEdit ? detailNeedTruckDriverLicense.value : need_truck_driver_license.value != 1,
        },
        {
          type: 'input',
          field: 'trailer_license',
          label: '挂车号牌（车型为挂车必填）',
          hidden: !props.canEdit ? detailNeedTrailerRegistration.value : need_trailer_registration.value != 1,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'trailer_registration_photo',
          label: '挂车行驶证及挂车图片（含车牌号）',
          number: 10,
          hidden: !props.canEdit ? detailNeedTrailerRegistration.value : need_trailer_registration.value != 1,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'truck_compulsory_insurance_photo',
          label: '强制险图片',
          number: 10,
          hidden: !props.canEdit ? detailNeedTruckCompulsoryInsurance.value : need_truck_compulsory_insurance.value != 1,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'truck_commercial_insurance_photo',
          label: '商业险图片（重型货车的商业险第三者必须100万以上）',
          number: 10,
          hidden: !props.canEdit ? detailNeedTruckCommercialInsurance.value : need_truck_commercial_insurance.value != 1,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'blind_video_photo',
          label: '盲区监控视频图片（1.前侧右侧盲区安装证明，2.能同时看见车牌号与前右侧盲区摄像头和声光报警器的车身图片，3.驾驶室内盲区显示屏）',
          number: 20,
          hidden: !props.canEdit ? detailNeedVideo.value : need_blind_video.value != 1,
          //hidden: need_record.value != 1,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'register_record_photo',
          label: '备案车辆信息登记表图片',
          number: 20,
          hidden: !props.canEdit ? detailNeedRecord.value : need_record.value != 1,
        },
      ],
    },
    {
      name: '泥头车信息文件',
      submitInObject: true,
      hidden: !showDumpTruck.value,
      id: 'dump_truck_file',
      dataInObject: 'dump_truck_file',
      formItem: [
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'driver_license',
          label: '驾驶证图片',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'driving_license',
          label: '行驶证图片',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'compulsory_insurance',
          label: '强制险图片',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'commercial_insurance',
          label: '商业险图片',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'excess_insurance',
          label: '超额险图片',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'commitment_letter',
          label: '重点运输单位承诺书图片',
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'monitor_return_receipt',
          label: '智能视频监控报警装置安装回执图片',
        },
      ],
    },
    {
      name: '来访信息',
      id: 'visiting_information',
      formItem: [
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          // storeOptions: 'areaType',
          options: constantToOptions(areaTypeConst),
        },
        {
          type: 'radio',
          storeOptions: 'carVisitTypeForApplication',
          field: 'visitor_type',
          label: '申请类型',
          hidden: !showSpecialVehicleFields.value,
          tips: [
            // '施工车辆访问时间不能超过一个月，通行时间段为9:00-18:00！ ',
            // '维修车辆访问时间不能超过一个月，通行时间段为9:00-18:00！',
            '临时车辆访问时间不能超过三天，通行时间段为9:00-18:00！',
            '服务商类型：危化品车辆访问时间不能超过三个月，泥头车访问时间不能超过一个月，其他车型不能超过6个月，通行时间段为9:00-18:00！',
            // '业主车辆访问时间不能超过一年',
          ],
          onChange: ({ target }) => {
            // 保存到全局
            store.dispatch('common/setCurrentVisitorType', target.value)

            // 更新当前选择的申请类型
            currentVisitorType.value = target.value

            // 清空来访/截止时间
            const formRefs = multipleFormRef?.value?.formRefs
            const visitForm = formRefs?.visiting_information
            if (visitForm?.formState) {
              visitForm.formState.visitor_begin_time = ''
              visitForm.formState.visitor_end_time = ''
            }

            // if (target.value == 5) {
            //   showWorkCertificatePhoto.value = true;
            // } else {
            //   showWorkCertificatePhoto.value = false;
            // }
          },
        },
        {
          type: 'input',
          field: 'interviewee_name',
          label: '被访问人',
        },
        {
          type: 'input',
          field: 'interviewee_phone',
          label: '被访问人电话',
        },
        {
          type: 'select',
          field: 'interviewee_depart_id',
          label: '被访问机构',
          storeOptions: 'dept',
          onChange: (depart_id) => {
            const depart = deptType.value?.[depart_id]
            depart && (departType.value = depart)
          }
        },
        {
          type: 'input',
          field: 'visitor_content',
          label: '来访事由',
        },
        {
          type: 'dateRange',
          startField: 'visitor_begin_time',
          endField: 'visitor_end_time',
          label: '来访时间',
          hidden: !showSpecialVehicleFields.value,
          disabledDate(current, dayjs) {
            return current < dayjs().add(2, 'day').endOf('day')
          },
          onCalendarChange() {},
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'work_certificate_photo',
          label: '服务商车辆入园申请表',
          number: 4,
          hidden: showSpecialVehicleFields.value,
          /*hidden: props.editData?.visitor_type != 5
            || props.editData?.depart_info?.depart_type == 2
            || props.editData?.vehicle_type?.name.includes('危'),*/
        },
      ],
    },
    {
      name: '驾乘人员信息',
      id: 'driver_info',
      dataIdFiled: 'car_person_id',
      dynamic: true,
      formItem: [
        {
          type: 'input',
          field: 'name',
          label: '姓名',
          required: false,
        },
        {
          type: 'select',
          field: 'idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
          required: false,
        },
        {
          type: 'input',
          field: 'id_card',
          label: '证件号',
          required: false,
        },
        {
          type: 'radio',
          field: 'gender',
          label: '性别',
          options: constantToOptions(gender),
          required: false,
        },
        {
          type: 'input',
          field: 'phone',
          label: '联系电话',
          required: false,
        },
        {
          type: 'radio',
          field: 'type',
          label: '驾乘分类',
          storeOptions: 'driverType',
          width: '400px',
          required: false,
        },
        {
          type: props.canEdit ? 'imgUpload' : 'image',
          field: 'face_photo',
          label: '人像照片',
          required: false,
        },
      ],
    },
  ])

  function cargoTypeChange(data) {
    if (data.target.value === '1') showDanger.value = true
    else showDanger.value = false
  }

  //提交
  async function handelSubmit(data) {
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}
    const filteredData = filterData(data, !showCargo.value, [
      'total_mass',
      'cargo_name',
      'cargo_type',
      'cargo_info',
    ])

    /*const { vehicle_type_id, visitor_type, visitor_begin_time, visitor_end_time } = filteredData
    const carTypeName = carModelObj?.value?.[vehicle_type_id]?.name
    const isSpecialVehicle =
      carTypeName?.indexOf('危') > -1 ||
      carTypeName?.indexOf('泥头车') > -1 ||
      carTypeName?.indexOf('搅拌车') > -1
    const isSpecialVisitor = visitor_type == 1 || visitor_type == 2
    if (isSpecialVehicle && isSpecialVisitor && visitor_begin_time && visitor_end_time) {
      const startDate = dayjs(visitor_begin_time);
      const endDate = dayjs(visitor_end_time);
      const monthDiff = endDate.diff(startDate, 'month');
      if (!(monthDiff >= 0 && monthDiff < 3)) {
        return message.warn('来访时间不能超过3个月');
      }
    }*/

    if (Array.isArray(filteredData.img12123)) {
      filteredData.img12123 = filteredData.img12123?.map(item => item.url)?.join(';');
    }
    if (Array.isArray(filteredData.blind_video_photo)) {
      filteredData.blind_video_photo = filteredData.blind_video_photo?.map(item => item.url)?.join(';');
    }
    if (Array.isArray(filteredData.trailer_registration_photo)) {
      filteredData.trailer_registration_photo = filteredData.trailer_registration_photo?.map(item => item.url)?.join(';');
    }
    if (Array.isArray(filteredData.truck_driver_license_photo)) {
      filteredData.truck_driver_license_photo = filteredData.truck_driver_license_photo?.map(item => item.url)?.join(';');
    }
    if (Array.isArray(filteredData.truck_compulsory_insurance_photo)) {
      filteredData.truck_compulsory_insurance_photo = filteredData.truck_compulsory_insurance_photo?.map(item => item.url)?.join(';');
    }
    if (Array.isArray(filteredData.truck_commercial_insurance_photo)) {
      filteredData.truck_commercial_insurance_photo = filteredData.truck_commercial_insurance_photo?.map(item => item.url)?.join(';');
    }
    if (Array.isArray(filteredData.register_record_photo)) {
      filteredData.register_record_photo = filteredData.register_record_photo?.map(item => item.url)?.join(';');
    }
    if (Array.isArray(filteredData.work_certificate_photo)) {
      filteredData.work_certificate_photo = filteredData.work_certificate_photo?.map(item => item.url)?.join(';');
    }

    const res = await ajaxFn({ ...filteredData, ...id })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }

  function filterData(data, doFilter, fields) {
    let newData = JSON.parse(JSON.stringify(data))
    if (doFilter) {
      fields.forEach((item) => delete newData[item])
      return newData
    }
    return data
  }

  //批量导入
  function bulkImportSuccess() {
    setTimeout(() => {
      emit('submit')
    }, 1000)
  }
  function bulkImportError(e) {
    console.log('errorrrr')
  }
</script>
<style scoped lang="less">
  .tool_box {
    display: flex;
    justify-content: flex-end;
  }
</style>
